goog.provide('el8.data.model.tag');

goog.require('el8.model.base');

/**
 * Super simple shared code for patient tags (el8.ptdata.ptTags),
 * document tags (el8.data.docTags), and any other tag types we add in the future
 */
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('value', true);

    el8.data.model.tag = function(spec) {
        return new _class(spec);
    };

})();

